/**
 * Point d'entrée de l'application React.
 * Met en place l'élément racine et rend le composant App.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import { initPostHog } from "@repo/utils";
import { App } from "./App";

initPostHog("ent-struct");

// Initialise le client Convex
const convex = new ConvexReactClient(
  process.env.BUN_PUBLIC_CONVEX_URL as string,
);

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <ConvexProvider client={convex}>
      <App />
    </ConvexProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // Avec le rechargement à chaud des modules, `import.meta.hot.data` persiste.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // L'API de rechargement à chaud n'est pas disponible en production.
  createRoot(elem).render(app);
}
